export default __webpack_public_path__ + "static/media/proposta-online-logo.01accd35.svg";